function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import { withRouter } from "next/router";
import { sameUrls } from "/utils/url";
import colors from "styles/colors";
import { LOGIN_PAGE_LINK } from "constants/links";
import { TOPBAR_LOGIN_BUTTON_CLASS } from "/constants/topbar-selectors";
import TopBarBaseComponent from "../top-bar-base/top-bar-base-component";
import OutlineButtonComponent from "../outline-button/outline-button-component";
import TopBarDesktopLinkWithMenuComponent from "./top-bar-desktop-link-with-menu/top-bar-desktop-link-with-menu-component";
import TopbarLoginSignupComponent from "./topbar-login-signup/topbar-login-signup-component";
import { StyledTopbarDesktopComponent, StyledMenu } from "./top-bar-desktop-component.scss";
import { getHeaderComponents } from "services/localization/localization-service";
import { withAbTests } from "/contexts/ab-tests-context";
import { withGenericConfig } from "contexts/generic-config-context";
const POSSIBLE_HOVER_COLORS = [
    "brand-purple",
    "brand-green",
    "brand-pink",
    "brand-blue"
];
class TopbarDesktopComponent extends PureComponent {
    onScrollModeChange(isInScrollMode) {
        this.setState({
            isInScrollMode
        });
    }
    getLinkClassName(headerLink) {
        const { router = {} } = this.props;
        const selected = headerLink.menuLinks ? !!this.getMenuLinkActiveLinkText(headerLink) : sameUrls(headerLink, router.asPath);
        return classnames("top-bar-link", {
            selected
        });
    }
    getMenuLinkActiveLinkText(headerLinkMenu) {
        const { router = {} } = this.props;
        const { links, bottomLinks } = headerLinkMenu.menuLinks;
        const allLinks = _object_spread({}, links, bottomLinks);
        let activeLinkText = null;
        Object.keys(allLinks).forEach((linkText)=>{
            if (sameUrls(allLinks[linkText], router.asPath)) activeLinkText = linkText;
        });
        return activeLinkText;
    }
    renderLinkWithMenu(headerLinkText, headerLinkMenu, hoverColor) {
        const { localeId } = this.props;
        const className = headerLinkMenu.className;
        return /*#__PURE__*/ _jsx(StyledMenu, {
            className: `${className} topbar-menu-wrapper`,
            children: /*#__PURE__*/ _jsx(TopBarDesktopLinkWithMenuComponent, {
                menuItems: headerLinkMenu.menuLinks,
                hoverColor: hoverColor,
                localeId: localeId,
                children: this.renderLink(headerLinkText, headerLinkMenu, hoverColor)
            })
        });
    }
    getLinkUrl(headerLink) {
        return headerLink.menuLinks ? undefined : headerLink;
    }
    renderLink(headerLinkText, headerLink, hoverColor) {
        const { theme, isInScrollMode, translate } = this.props;
        const linkUrl = this.getLinkUrl(headerLink);
        return /*#__PURE__*/ _jsx("span", {
            className: "outline-button-header-link-wrapper",
            children: /*#__PURE__*/ _jsx(OutlineButtonComponent, {
                url: linkUrl,
                text: translate(headerLinkText),
                theme: theme,
                isInScrollMode: isInScrollMode,
                buttonStyle: "textual",
                linkClassName: this.getLinkClassName(headerLink)
            })
        });
    }
    getHeaderLinks() {
        const { desktopHeaderLinks, shortHeader, localeId } = this.props;
        return desktopHeaderLinks ? desktopHeaderLinks : getHeaderComponents(localeId, shortHeader);
    }
    renderHeaderLink(headerLinkText, index) {
        const header = this.getHeaderLinks();
        const headerLink = header.links[headerLinkText];
        if (!headerLink) return null;
        const color = POSSIBLE_HOVER_COLORS[index % POSSIBLE_HOVER_COLORS.length];
        return /*#__PURE__*/ _jsx("div", {
            className: "top-header-link-wrapper",
            children: headerLink.menuLinks ? this.renderLinkWithMenu(headerLinkText, headerLink, color) : this.renderLink(headerLinkText, headerLink, color)
        }, headerLinkText);
    }
    renderLoginLink() {
        const { theme, isInScrollMode, loginUrl, translate } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: "top-header-login-link-wrapper",
            children: /*#__PURE__*/ _jsx(OutlineButtonComponent, {
                url: loginUrl || LOGIN_PAGE_LINK,
                text: translate("signup.logIn"),
                theme: theme,
                isInScrollMode: isInScrollMode,
                buttonStyle: "circled",
                linkClassName: `${TOPBAR_LOGIN_BUTTON_CLASS} login-top-bar`
            })
        });
    }
    renderLoginSignupComponentWithSeperator() {
        const { isInScrollMode } = this.state;
        return /*#__PURE__*/ _jsx("div", {
            className: "topbar-login-signup-wrapper",
            children: /*#__PURE__*/ _jsx(TopbarLoginSignupComponent, {
                isInScrollMode: isInScrollMode
            })
        });
    }
    render() {
        const header = this.getHeaderLinks();
        const headerLinksText = Object.keys(header.links);
        return /*#__PURE__*/ _jsx(TopBarBaseComponent, _object_spread_props(_object_spread({}, this.props), {
            onScrollModeChange: this.onScrollModeChange,
            children: /*#__PURE__*/ _jsxs(StyledTopbarDesktopComponent, {
                className: "navbar-menu",
                children: [
                    headerLinksText.map(this.renderHeaderLink),
                    this.renderLoginLink()
                ]
            })
        }));
    }
    constructor(props){
        super(props);
        this.state = {
            isInScrollMode: false
        };
        this.onScrollModeChange = this.onScrollModeChange.bind(this);
        this.renderHeaderLink = this.renderHeaderLink.bind(this);
    }
}
TopbarDesktopComponent.defaultProps = {
    stickyMode: false,
    allowSocialButtons: false,
    socialButtonsColor: "black",
    socialButtonBlogStyle: false,
    translate: (key)=>key
};
export default withAbTests(withGenericConfig(withRouter(TopbarDesktopComponent)));
